import { SVG, SVGProps } from './svg'

export function IconToolBrush(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M11.66 15.5h.63c.34.07.66.24.9.5L16 18.82c.23.22.43.54.48.91V20.33c0 1.28-.5 2.5-1.4 3.42h-.01a8.9 8.9 0 01-6.77 2.48c-.8 0-1.58-.26-2.22-.76l-.02-.02-.03-.02a1.04 1.04 0 01-.11-1.31 5.9 5.9 0 00.87-3.27v-.06c.08-1.24.17-2.61 1.45-3.88.9-.9 2.13-1.41 3.41-1.41zm.47 1h-.47c-1.01 0-1.99.4-2.7 1.12-1 1-1.08 2.02-1.16 3.29a6.87 6.87 0 01-1.04 3.77.04.04 0 00-.01.03c.45.34 1 .52 1.58.52h.03a7.9 7.9 0 006.02-2.19 3.86 3.86 0 001.11-2.71v-.5a.57.57 0 00-.17-.29l-2.85-2.85a.69.69 0 00-.34-.2zM23.66 6.76a.04.04 0 00-.06 0l-8.82 8.11a.04.04 0 000 .06l2.28 2.27a.04.04 0 00.05 0l8.12-8.81a.04.04 0 000-.06h-.01l-1.56-1.57zm-.74-.73c.4-.38 1.03-.37 1.43 0v.02l1.56 1.54a1.04 1.04 0 01.05 1.49l-8.12 8.81a1.04 1.04 0 01-1.5 0l-2.26-2.25a1.04 1.04 0 010-1.5h.02l8.82-8.1z"
      />
    </SVG>
  )
}
